'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _SocialButtons = require('./SocialButtons.css');

var _SocialButtons2 = _interopRequireDefault(_SocialButtons);

var _reactSocial = require('react-social');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialButtons = (_dec = (0, _reactCssModules2.default)(_SocialButtons2.default, { allowMultiple: false }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(SocialButtons, _Component);

  function SocialButtons(props) {
    (0, _classCallCheck3.default)(this, SocialButtons);
    return (0, _possibleConstructorReturn3.default)(this, (SocialButtons.__proto__ || (0, _getPrototypeOf2.default)(SocialButtons)).call(this, props));
  }

  (0, _createClass3.default)(SocialButtons, [{
    key: 'render',
    value: function render() {
      var message = this.props.message;
      var link = this.props.link;

      return _react2.default.createElement(
        'div',
        { styleName: 'social-buttons' },
        _react2.default.createElement(
          'div',
          { styleName: 'social-buttons-inner' },
          _react2.default.createElement(
            'div',
            { styleName: 'share-actions' },
            _react2.default.createElement(
              'div',
              { styleName: 'share' },
              'Share'
            ),
            _react2.default.createElement(
              _reactSocial.TwitterButton,
              {
                title: 'Share via Twitter',
                message: message,
                url: link,
                element: 'a',
                styleName: 'social-button-twitter' },
              _react2.default.createElement('i', { className: 'fa fa-twitter', styleName: 'social-icon-twitter' })
            ),
            _react2.default.createElement(
              _reactSocial.FacebookButton,
              {
                title: 'Share via Facebook',
                message: message,
                appId: _config2.default.socialAppId,
                url: link,
                element: 'a',
                styleName: 'social-button-facebook' },
              _react2.default.createElement('i', { className: 'fa fa-facebook', styleName: 'social-icon-facebook' })
            ),
            _react2.default.createElement(
              _reactSocial.EmailButton,
              {
                title: 'Share via E-Mail',
                message: message,
                url: link,
                element: 'a',
                styleName: 'social-button-email' },
              _react2.default.createElement('i', { className: 'fa fa-envelope-o', styleName: 'social-icon-email' })
            )
          )
        )
      );
    }
  }]);
  return SocialButtons;
}(_react.Component), _class2.propTypes = {
  message: _react.PropTypes.string.isRequired,
  link: _react.PropTypes.string.isRequired
}, _temp)) || _class);
exports.default = SocialButtons;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/SocialButtons/SocialButtons.js
// module id = 1393
// module chunks = 0